import { useQuery } from "@tanstack/react-query";
import { getWorkspaceRewardThresholds } from "api/services/workspace-service";
import { IUpdateRewardThresholdsRequest } from "api/models/request/IUpdateRewardThresholdsRequest";
import { WORKSPACE_REWARD_THRESHOLDS_QUERY_KEY } from "hooks/rewardThresholds/queryKeys";

export const useGetWorkspaceRewardThresholds = (workspaceId: string) => {
    const query = useQuery({
        queryKey: [...WORKSPACE_REWARD_THRESHOLDS_QUERY_KEY, workspaceId],
        queryFn: async (): Promise<IUpdateRewardThresholdsRequest> => {
            const response = await getWorkspaceRewardThresholds(workspaceId);
            if (!response.success || !response.data) {
                throw new Error("rewardThresholds.loadError");
            }

            return response.data;
        },
        enabled: !!workspaceId,
    });

    return {
        rewardThresholds: query.data,
        rewardThresholdsLoading: query.isPending,
        rewardThresholdsError: query.isError,
        refetchRewardThresholds: query.refetch,
    };
};
